// extracted by mini-css-extract-plugin
export default {"Flash":"DiscussionTemplateBanner-module__Flash--SIEaS"};